import SashiDo from 'lib/SashiDo';
import React, { Component, Fragment } from 'react';
import Button from 'components/Button/Button.react';
import Icon from 'components/Icon/Icon.react';
import Label from 'components/Label/Label.react';
import Notification from 'components/Notification/Notification.react';
import Field from 'components/Field/Field.react';
import KeyField from 'components/KeyField/KeyField.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import { jsonEqual } from 'lib/helpers';
import styles from 'dashboard/Settings/Settings.scss';


import TextInput from './TextInput/TextInput.react';


const regexPattern = /^[a-zA-Z_]([a-zA-Z0-9_]?)+$/;


const showDup = (data) => {
  const result = [];
  const names = [...new Set(data.map(a => a.name))];

  names.forEach((name) => {
    const indexes = data.map((item, i) => {
      item.index = i;
      return item;
    })
      .filter(a => a.name === name)
      .map(a => a.index);

    if (indexes.length > 1) {
      result.push({
        name,
        between: [indexes[0], indexes[indexes.length - 1]],
        count: indexes.length,
      });
    }
  });

  return result;
};


export default class Form extends Component {
  constructor() {
    super();
    this.state = {
      items: [],
      deletedItems: [],
      note: {},
      duplicates: [],
    };
  }

  async componentDidMount() {
    const data = await SashiDo.getEnvs(this.props.appId);

    const envRO = [];
    const items = [];

    data.forEach((item) => {
      if (item.perm === 'ro') {
        envRO.push(item);
      }

      if (item.perm === 'rw') {
        items.push(item);
      }
    });


    this.setState({
      envRO,
      items,
      originalItems: items,
    });

    this.props.onLoadComplete();
  }

  shouldComponentUpdate(nextProps) {
    if (!nextProps && this.props === nextProps) {
      return false;
    }
    return true;
  }

  onModifiedFields() {
    setTimeout(() => {
      const { originalItems, items } = this.state;
      const emptyItems = items.filter(u => u.name === '');

      if (emptyItems.length !== 0) {
        this.props.toggleFooter(true);
      } else if (!jsonEqual(items, originalItems) && (items.length !== 0 || this.state.deletedItems.length === originalItems.length)) {
        // show footer
        this.props.toggleFooter();
      } else {
        // hide footer
        this.props.toggleFooter(true);
      }
    }, 100);
  }

  onChange = (idx, type) => (evt) => {
    const inputString = evt.target.value;

    const newItems = this.state.items.map((item, sidx) => {
      if (idx !== sidx) return item;

      return { ...item, [type]: type === 'name' ? inputString.toUpperCase().trim() : inputString };
    });

    const duplicates = showDup(newItems);

    this.setState({ items: newItems, note: null, duplicates: [] });
    this.onModifiedFields();

    if (inputString.length === 0) {
      return;
    }


    if (duplicates.length > 0) {
      const envVariables = duplicates.map(u => u.name).join(', ').replace(/,(?!.*,)/gmi, ' and');
      const plural = duplicates.length > 1 ? 's' : '';

      this.setState({
        duplicates,
        items: newItems,
        note: {
          type: 'error',
          message: `Environment${plural} ${envVariables} already exist${plural}!`,
        },
      });

      this.props.toggleFooter(true);
    }

    const currentItems = !regexPattern.test(newItems[idx].name);

    if (currentItems) {
      this.setState({
        note: {
          type: 'error',
          message: 'Environment Variables names should not contain hyphens and spaces and should not start with numbers.',
        },
      });
    }
  }

  handleAddShareholder = () => {
    this.setState({
      items: this.state.items.concat([{ name: '', value: '', perm: 'rw' }]),
      note: null,
    });

    this.onModifiedFields();
  }

  handleRemoveShareholder = idx => () => {
    const { items } = this.state;

    const itemsArr = items.filter((s, sidx) => idx !== sidx);
    const deletedItems = items.filter((s, sidx) => idx === sidx);

    this.setState({
      items: itemsArr,
      deletedItems: [...this.state.deletedItems, ...deletedItems],
      note: null,
    });

    this.onModifiedFields();
  }

  handleSave = () => {
    this.setState({ saving: true });

    const newEnv = this.state.items.filter(u => u.name !== '').map((u) => {
      delete u.perm;
      return u;
    });

    const newEnvRO = this.state.envRO.map((u) => {
      delete u.perm;
      return u;
    });

    SashiDo.setEnvs(
      this.props.appId,
      {
        env: [...newEnv, ...newEnvRO],
      },
    ).then(() => {
      this.setState({
        saving: false,
        originalItems: this.state.items,
        note: {
          type: 'success',
          message: 'Your Parse Server Environment Variables were successfully updated.',
        },
      });

      this.props.toggleFooter(true);
    })
      .catch((e) => {
        this.setState({
          saving: false,
          // items: this.state.originalItems,
          note: {
            type: 'error',
            message: e.response.data,
          },
        });

        this.props.toggleFooter(true);
      });
  }

  render() {
    const {
      items, envRO, duplicates,
    } = this.state;

    if (!items || !envRO) {
      return null;
    }

    return (
      <Fragment>
        <Fieldset
          legend="Environment Variables"
          description="An environment variable is a dynamic-named value that can affect the way running processes will behave on a computer.">
          <Notification note={this.state.note} close={!this.state.note} />

          <div className={styles.settingsBox}>
            <div className={styles.twoColsHolder}>
              <Field
                label={<Label text="Read-only Environment Variables" />}
                input={
                  envRO.map((item, i) => {
                    return (
                      <Fragment key={item.name}>
                        <div className={styles.twoColsRow} style={i === 0 ? { paddingTop: 10 } : {}}>
                          <KeyField>{item.name}</KeyField>
                          <KeyField>{item.value}</KeyField>
                        </div>

                        {
                          envRO.length !== i + 1 &&
                          <div className={styles.hr} />
                        }
                      </Fragment>
                    );
                  })
                } />

              <br />
              <br />

              <Field
                label={<Label text="Custom Environment Variables" />}
                input={
                  <Fragment>
                    {
                      items.map((item, idx) => {
                        return (
                          <Fragment key={`${item}-${idx}`}>
                            <div className={styles.threeColsRow} style={idx === 0 ? { paddingTop: 10 } : {}}>
                              <TextInput
                                uppercase
                                error={duplicates.some(u => u.name === item.name)}
                                placeholder="name"
                                value={item.name}
                                onChange={this.onChange(idx, 'name')} />

                              <TextInput
                                value={item.value}
                                placeholder="value"
                                onChange={this.onChange(idx, 'value')} />

                              <span className={styles.remove} onClick={this.handleRemoveShareholder(idx)}>
                                <Icon name="minus-solid" width={14} height={14} fill="rgba(0,0,0,0.4)" />
                              </span>
                            </div>

                            {
                              items.length !== idx + 1 &&
                              <div className={styles.hr} />
                            }
                          </Fragment>
                        );
                      })
                    }

                    <div className={styles.hr} />


                    <div className={styles.twoColsRow}>
                      <Button color="blue" value="Add Environment Variable" onClick={this.handleAddShareholder} />
                    </div>
                  </Fragment>
                } />
            </div>
          </div>
        </Fieldset>

        <div className={[styles.customFooter, this.props.showFooter ? styles.ShowFooter : ''].join(' ')}>
          <Button color="green" value="Save &amp; Deploy" progress={this.state.saving} onClick={this.handleSave} />
        </div>
      </Fragment>
    );
  }
}
